import { AnimatePresence, motion } from "motion/react";
import { UploadModalStatusPage } from "@/components/vault/viewer/backgrounds/UploadModalStatusPage";
import React from "react";

interface UploaderBackgroundProps {
  uploadLoading: boolean;
  uploadComplete: boolean;
  uploadFailed: boolean;
}

export const UploaderBackground = ({
  uploadLoading,
  uploadComplete,
  uploadFailed,
}: UploaderBackgroundProps) => {
  return (
    <div className="relative flex flex-col items-center justify-center w-full h-full">
      <AnimatePresence mode="wait">
        <motion.div
          className="w-full h-full flex flex-col items-center justify-center gap-1"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
        >
          <UploadModalStatusPage
            uploadLoading={uploadLoading}
            uploadComplete={uploadComplete}
            uploadFailed={uploadFailed}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
